import { addDatapointConfig } from 'owa-analytics-actions';
import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * Action dispatched when suggestions should be set in the store. Consuming client
 * should set up an orchestrator to subscribe to it, which should read appropriate
 * values from the search store, fetch suggestions, and set them in the store.
 */
const getSuggestions = action('GET_SUGGESTIONS', (scenarioId: SearchScenarioId) =>
    addDatapointConfig(
        {
            name: 'Search_SuggestionsE2E',
        },
        {
            scenarioId,
        }
    )
);

export default getSuggestions;
